'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  NO_LINK: null,
  PAGE_LINK: null,
  PAGE_LINK_WITH_PARAMS: null,
  URL_LINK: null
}));